module.exports = __webpack_public_path__ + "static/assets/36e5c27f55746ecb826a932646d59f5c.svg";